<template>
    <v-card>
        <v-card-title>Edit Ad Hoc Factor Type</v-card-title>
        <v-card-text>
            <v-text-field v-model="name" label="Name"/>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script setup lang="ts">

import { ref } from "vue";
import { AdHocFactorType, SavedAdHocFactorType } from "@/services/conditions/conditionFactors/conditionFactorsAPI";

const { adHocFactorType } = defineProps<{
    adHocFactorType?: SavedAdHocFactorType | undefined;
}>();

const emit = defineEmits<{
    (e: "onSave", adHocFactorType: AdHocFactorType | SavedAdHocFactorType): void;
}>();

const name = ref<string>( adHocFactorType ? adHocFactorType.name : "");

async function save() {
    emit("onSave", {
        ...adHocFactorType,
        name: name.value!
    });
}

</script>
